import * as React from "react";
import {gql} from "@apollo/client";
import moment from "moment/moment";
import {mutate, query} from "../../lib/apollo";
import Loading from "../../components/loading";
import {
    Alert, FormControl, Grid, IconButton,
    Input,
    InputAdornment,
    Paper,
    Table, TableBody,
    TableCell,
    TableContainer, TableFooter,
    TableHead,
    TableRow,
    Menu,
    MenuItem
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Button from "@mui/material/Button";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import StripedTableRow from "../../components/StripedTableRow";
import TableFooterRow from "../../components/TableFooterRow";
import TableHeaderRow from "../../components/TableHeaderRow";
import {toast} from "react-toastify";
import {CheckCircleOutline, PauseCircleOutline, RecyclingOutlined} from "@mui/icons-material";
import CostQueueUpsert from "./costQueueUpsert";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';

export default function CostQueuePage() {

    const [results, setResults] = React.useState([] as any);
    const [pace, setPace] = React.useState(0 as any);
    const [loading, setLoading] = React.useState(true);
    const [upsert, setUpsert] = React.useState<any>(null as any);
    const [anchorEls, setAnchorEls] = React.useState<any>({});

    React.useEffect(() => {
        document.title = "Cost Queue | DN";
        reload().then(x=> {

        });

    }, []);

    const updatePace = async () => {
        setLoading(true);
        const q = gql`
            mutation m ($input: Int!) {
                costQueuePaceUpdate(pace: $input) 
            }
        `;

        const variables = {
            input: parseInt(pace, 10)
        };

        const response = await mutate(q, variables);
        if (response && response.costQueuePaceUpdate) {
            toast.success("Pace updated successfully");
        }
        setLoading(false);
    }

    const reload = async () => {
        setLoading(true);

        const q = gql`
            query {
                costQueuePace
                costQueue {
                    id
                    date
                    cost
                    applied
                    notes
                    active
                }
            }
        `;

        const response = await query(q, null);

        if (response) {
            setResults(response.costQueue);
            setPace(response.costQueuePace);
        }

        setLoading(false);
    }

    return (
        <>
            <h2>Cost Queue</h2>


            {loading ? <Loading/> :
                <>
                    <Grid container>
                        <Grid item xs={6} md={4}>
                            <Input
                                id="search"
                                type="number"
                                spellCheck="false"
                                placeholder="Hourly Pace"
                                value={pace}
                                onChange={(e: any) => {setPace(e.target.value);} }
                                startAdornment={<InputAdornment position="start">$</InputAdornment>}
                                endAdornment={<InputAdornment position="end">.00 / hr</InputAdornment>}
                                sx={{maxWidth: '200px', marginLeft: 'auto'}}
                            />
                            <FormControl sx={{marginLeft: '10px' }} size="small">
                                <Button aria-label="Add" onClick={() => updatePace()} variant={'contained'} color={'info'}>
                                    Update
                                </Button>
                            </FormControl>
                        </Grid>

                        <Grid item xs={6} md={4}>
                            <FormControl sx={{minWidth: 120, marginLeft: '10px' }} size="small">
                                <Button aria-label="Add" onClick={() => {setUpsert({id: 0})}} variant={'contained'} color={'warning'}>
                                    <AddBoxOutlinedIcon />&nbsp;Add Cost
                                </Button>
                            </FormControl>
                        </Grid>
                        <Grid item xs={1} md={4}>
                            <FormControl sx={{marginLeft: '10px' }} size="small">
                                <Button aria-label="Reload" onClick={() => {reload()}} variant={'contained'} color={'success'}>
                                    <RecyclingOutlined />
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <p></p>
                    {results.length === 0 ? <Alert severity="warning">No results found</Alert> :
                        <TableContainer component={Paper} sx={{maxWidth: 'calc(100vw - 10px)'}}>
                            <Table size={"small"}>
                                <TableHead>
                                    <TableHeaderRow>
                                        <TableCell align="right">Date</TableCell>
                                        <TableCell align="right">Amount</TableCell>
                                        <TableCell align="right">Applied</TableCell>
                                        <TableCell align="left">Notes</TableCell>
                                        <TableCell>&nbsp;</TableCell>
                                    </TableHeaderRow>
                                </TableHead>
                                <TableBody>
                                    {results.map((row: any) => {
                                        return (
                                            <StripedTableRow key={row.id}>
                                                <TableCell align="right">{row.date}</TableCell>
                                                <TableCell align="right">${row.cost.toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits: 2})}</TableCell>
                                                <TableCell align="right">
                                                    {row.applied >= row.cost && <CheckCircleOutline sx={{verticalAlign: 'text-top', color: 'green', fontSize: '18px'}}/>}
                                                    {!row.active && <PauseCircleOutline sx={{verticalAlign: 'text-top', color: 'red', fontSize: '18px'}}/>}
                                                    ${row.applied.toLocaleString(undefined, {maximumFractionDigits:2, minimumFractionDigits: 2})}</TableCell>
                                                <TableCell align="left">{row.notes}</TableCell>
                                                <TableCell align={"center"}>
                                                    <IconButton
                                                        aria-haspopup="true"
                                                        onClick={(event) => {
                                                            setAnchorEls({...anchorEls, [row.id]: event.currentTarget});
                                                        }}
                                                    >
                                                        <MoreVertIcon sx={{fontSize: '15px'}} />
                                                    </IconButton>
                                                    <Menu
                                                        anchorEl={anchorEls[row.id]}
                                                        open={!!anchorEls[row.id]}
                                                        onClose={() => {
                                                            setAnchorEls({...anchorEls, [row.id]: null});
                                                        }}
                                                    >
                                                        <MenuItem onClick={() => {
                                                            setUpsert(row);
                                                            setAnchorEls({...anchorEls, [row.id]: null});
                                                        }} disableRipple><EditIcon sx={{marginRight: 1}} /> Edit Cost</MenuItem>
                                                    </Menu>
                                                </TableCell>
                                            </StripedTableRow>
                                        );
                                    })}
                                </TableBody>
                             </Table>
                        </TableContainer>
                    }
                </>}
            <CostQueueUpsert costQueue={upsert} setOpen={setUpsert} reload={reload}/>
        </>
    )
}
